import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getReferralWallet = async (queryParams:any) => {
    try {
  return await get<ApiResponse<[]>>(`/referral/wallet?${queryParams}`).then((res)=> {
    if(res?.success===true){
        return res
    }
    else {

    }
  })
}
catch(e){

}
};
